import { FaClock, FaChartLine, FaBookOpen, FaMoneyBill, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Windows & Doors Team Today",
    description: "At Windows & Doors, we're seeking committed individuals to join our team of experts. Explore rewarding career opportunities in windows and doors services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Opportunities in Window Installation",
        "Assist in Door Security Operations",
        "Advanced Window & Door Training Programs",
        "Door Security Situation Management",
        "Support in Window & Door Security Measures",
    ],
    image: {
        src: images.careerIntro,
        alt: "Career-Image",
    },
};

const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description: "Explore opportunities for career growth and advancement within the windows and doors industry. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description: "Participate in comprehensive training programs to enhance your skills and knowledge in windows and doors services. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Enjoy competitive pay packages and benefits while working in the windows and doors industry. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours that accommodate your schedule and lifestyle needs in the windows and doors industry. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Support",
        description: "Experience a supportive team environment where collaboration and teamwork are valued in the windows and doors industry. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description: "Unlock opportunities for personal and professional growth with ample room for advancement in the windows and doors industry. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Enim magnam aut incidunt repellendus voluptatum.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Window Installer',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Window Installation',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are seeking experienced Window Installers to join our professional team. As a Window Installer, you will be responsible for precise and secure installation of various window types. Candidates should possess strong craftsmanship, attention to detail, and the ability to work both independently and within a team environment.',
        ],
        responsibilities: [
            'Installing residential and commercial windows with precision.',
            'Ensuring airtight and secure fitting to prevent energy loss.',
            'Using proper sealing techniques to weatherproof windows.',
            'Following safety guidelines and maintaining clean workspaces.',
            'Inspecting and troubleshooting window installation issues.',
            'Collaborating with project managers and team members.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in window installation.',
            'Proficiency with tools and equipment used in window fitting.',
            'Ability to lift heavy materials and work at various heights.',
            'Attention to safety, quality, and client satisfaction.',
            'Strong problem-solving and communication skills.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Door Technician',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Door Installation and Maintenance',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a skilled Door Technician to join our team. As a Door Technician, you will be responsible for the installation, repair, and maintenance of various door systems. Ideal candidates will have a strong understanding of different types of doors, their mechanisms, and troubleshooting techniques.',
        ],
        responsibilities: [
            'Installing and repairing a variety of doors, including interior, exterior, and specialty doors.',
            'Performing routine maintenance and repairs on door systems.',
            'Ensuring proper alignment, weatherproofing, and functionality of doors.',
            'Working with different materials such as wood, glass, and metal doors.',
            'Troubleshooting and resolving door system issues efficiently.',
            'Ensuring safety standards are followed during installations and repairs.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in door installation and repair.',
            'Familiarity with door mechanisms, locks, and security systems.',
            'Strong physical fitness and ability to lift and carry materials.',
            'Ability to read and interpret technical manuals and blueprints.',
            'Excellent communication skills and ability to work in a team.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Window Sales Representative',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 2 Years in Sales or Window Industry',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for an enthusiastic and motivated Window Sales Representative to join our team. In this role, you will be responsible for promoting and selling our window products to residential and commercial customers. If you have a passion for sales and a strong understanding of window products, we want to hear from you!',
        ],
        responsibilities: [
            'Generating new sales leads and maintaining relationships with existing clients.',
            'Presenting and demonstrating window products to customers.',
            'Providing expert advice on window selection, energy efficiency, and design options.',
            'Managing the sales process from initial contact to closing the sale.',
            'Collaborating with the installation team to ensure smooth order fulfillment.',
            'Meeting and exceeding monthly and annual sales targets.',
        ],
        qualifications: [
            'High school diploma or equivalent (Bachelor’s degree preferred).',
            'Minimum 2 years of sales experience, preferably in the window or construction industry.',
            'Strong communication, negotiation, and presentation skills.',
            'Ability to work independently and as part of a team.',
            'Proven track record of meeting or exceeding sales goals.',
            'Knowledge of window products, energy efficiency, and industry trends is a plus.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Door Sales Representative',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 2 Years in Sales or Door Industry',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a motivated and goal-oriented Door Sales Representative to join our dynamic sales team. As a Door Sales Representative, you will promote and sell our range of high-quality door products to residential and commercial clients. If you have a strong passion for sales and expertise in door products, we want to hear from you!',
        ],
        responsibilities: [
            'Developing and maintaining relationships with new and existing clients.',
            'Presenting and demonstrating door products, including security, interior, and exterior options.',
            'Providing detailed information on product features, benefits, and customization options.',
            'Managing the entire sales process from lead generation to closing deals.',
            'Collaborating with the installation and customer service teams to ensure seamless service delivery.',
            'Achieving and exceeding sales targets and KPIs.',
        ],
        qualifications: [
            'High school diploma or equivalent (Bachelor’s degree in Business, Marketing, or related field preferred).',
            'Minimum 2 years of experience in sales, preferably within the door or construction industry.',
            'Excellent verbal and written communication skills.',
            'Ability to develop and execute effective sales strategies.',
            'Strong problem-solving skills and attention to detail.',
            'Ability to work independently and manage multiple accounts.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Window and Door Installer',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Window and Door Installation',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are seeking skilled and dedicated Window and Door Installers to join our team. As a Window and Door Installer, you will be responsible for the installation and maintenance of both windows and doors for residential and commercial clients. If you are passionate about craftsmanship and providing high-quality service, we encourage you to apply.',
        ],
        responsibilities: [
            'Installing windows and doors, ensuring proper alignment, sealing, and security.',
            'Performing site assessments to measure and verify installation requirements.',
            'Ensuring that all installations meet safety and quality standards.',
            'Working with a range of materials, including wood, vinyl, aluminum, and glass.',
            'Collaborating with other team members to ensure timely and successful installations.',
            'Providing excellent customer service and addressing any concerns or questions from clients.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in window and door installation.',
            'Strong physical fitness and ability to work at heights.',
            'Knowledge of window and door materials, tools, and installation techniques.',
            'Ability to read and interpret technical documents and blueprints.',
            'Excellent communication and teamwork skills.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Sales Manager',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 5 Years in Sales Management',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a dynamic and experienced Sales Manager to lead our sales team. As a Sales Manager, you will be responsible for driving sales growth, managing sales representatives, and developing strategies to increase customer acquisition. If you are a results-driven leader with a passion for sales, we want to hear from you.',
        ],
        responsibilities: [
            'Developing and executing sales strategies to achieve company goals.',
            'Managing, training, and mentoring the sales team to maximize performance.',
            'Building and maintaining strong relationships with key clients and prospects.',
            'Analyzing sales data and market trends to identify new opportunities.',
            'Collaborating with marketing and operations teams to ensure sales objectives are met.',
            'Preparing and presenting regular sales reports to management.',
        ],
        qualifications: [
            'Bachelor’s degree in Business, Marketing, or a related field.',
            'Minimum 5 years of experience in sales management, with a proven track record of success.',
            'Strong leadership and team management skills.',
            'Excellent communication, negotiation, and interpersonal skills.',
            'Proficient in CRM software and sales analytics tools.',
            'Ability to work under pressure and meet sales targets.',
        ],
    }

];

export { positions, benefits, careerIntro };